import React from 'react';

import { addFilters } from '@/actions/rentals';
import LYRVBanner from '@/components/common/LYRV';
import HeadMeta from '@/components/static-pages/HeadMeta';
import LandingPageTemplate from '@/components/templates/LandingPageTemplate';
import getPageData from '@/services/getPageData.js';

export const genLandingPage = () => {
  return function LandingPage(props) {
    const { heading, subheading, seo_title, seo_description, canonical_url, url_path } =
      props.metadata || {};

    let seoTitle = seo_title ? seo_title : heading;
    let seoDescription = seo_description ? seo_description : subheading;
    const isRVInfoSubDirectory = url_path && url_path.match(/^\/rv-info\/[^/]+$/);

    return (
      <React.Fragment>
        <HeadMeta
          title={seoTitle}
          description={seoDescription}
          canonicalUrl={canonical_url}
          noindex={!!props.fallback}
        />
        {isRVInfoSubDirectory && <LYRVBanner />}
        <LandingPageTemplate {...props} />
      </React.Fragment>
    );
  };
};

export const genLandingPageGSSP = urlPath => {
  return async function getServerSideProps({ req, res, locale }) {
    const pageData = await getPageData({ req, res, query: { url_path: urlPath, locale } });

    return {
      props: pageData,
    };
  };
};

const LandingPage = genLandingPage();

LandingPage.getInitialProps = async ({ req, res, query, reduxStore }) => {
  const pageData = await getPageData({ req, res, query });

  const rvListing = pageData?.metadata?.content_blocks?.filter?.(b => b.type === 'rv-listing')?.[0];

  let defaultFilters = {};

  if (rvListing?.value) {
    defaultFilters = rvListing.value.default_filters || {};
    defaultFilters['page[limit]'] = rvListing.value.number || 8;
  }

  await reduxStore.dispatch(addFilters(defaultFilters));

  return { ...pageData };
};

export default LandingPage;
